import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

import Menu from './Menu';

const MenuItem = styled(Menu.Item)`
  color: ${colors.gray900};

  &:hover {
    background-color: #f7f9fe;
  }

  &.ant-menu-item-selected {
    background: ${colors.blue100};
    font-weight: 400;
  }
`;

export default MenuItem;
